module.exports = __webpack_public_path__ + "static/media/Outils_comm_02.6274452a.png";